import { getCookie } from 'cookies-next';

export const UTM_PARAM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
] as const;

type UtmKey = typeof UTM_PARAM_KEYS[number];
const UTM_MAX_LENGTH = 256;
const UTM_ALLOWLIST = /[a-z0-9._\-~%:/ ]/g;

export type UtmLastTouch = Partial<Record<UtmKey, string>> & {
  timestamp: string;
  landing_path: string;
};

export const hasAnalyticsConsent = () => getCookie('cc_analytics') === 'granted';

export const sanitizeUtmValue = (value: string) => {
  const trimmed = value.trim().toLowerCase();
  const noControls = Array.from(trimmed).filter((char) => {
    const code = char.charCodeAt(0);
    return code >= 0x20 && code !== 0x7F;
  }).join('');
  const allowed = noControls.match(UTM_ALLOWLIST)?.join('') ?? '';
  return allowed.slice(0, UTM_MAX_LENGTH);
};

export const extractUtmParams = (searchParams: URLSearchParams) => {
  const params: Partial<Record<UtmKey, string>> = {};

  UTM_PARAM_KEYS.forEach((key) => {
    const value = searchParams.get(key);
    if (value) {
      const sanitized = sanitizeUtmValue(value);
      if (sanitized) {
        params[key] = sanitized;
      }
    }
  });

  return Object.keys(params).length > 0 ? params : null;
};

export const buildLandingPath = (pathname: string, searchParamsString: string) => (
  searchParamsString ? `${pathname}?${searchParamsString}` : pathname
);
